import moment from 'moment';
import { mapState } from 'vuex';

export const MomentMixin = {
  methods: {
    momentDate(dateString, format) {
      let formatToUse = format ? format : 'll';
      const formattedDate = moment(dateString)
        .locale(this.defaultLanguage)
        .format(formatToUse);

      return formattedDate;
    },

    momentDateFromNow(dateString) {
      const formattedDate = moment(dateString)
        .locale(this.defaultLanguage)
        .fromNow();

      return formattedDate;
    }
  },

  computed: {
    ...mapState({
      defaultLanguage: state => state.defaultLanguage
    })
  }
};
